
/*
 * LavaLamp plugin
 */

 ;(function($) {
	'use strict';

	function LavaLamp(options) {
		this.options = $.extend({
			items: 'li',
			activeClass: 'active',
			activeLampClass: 'active',
			setOnClick: false,
			delayOn: 0,
			delayOff: 300,
			duration: 300
		}, options);
		this.init();
	}
	LavaLamp.prototype = {
		init: function() {
			if(this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function() {
			this.holder = $(this.options.holder).addClass('lavalamp-ready').css({
				position: 'relative',
				zIndex: 1
			});
			this.items = this.holder.find(this.options.items);
			this.lavaLampItem =  $('<li class="lavalamp-element"></li>').appendTo(this.holder).css({
				position: 'absolute',
				zIndex: -1,
				transitionDuration: this.options.duration + 'ms'
			});

			// set initial styles
			this.activeItem = this.items.filter('.' + this.options.activeClass);

			this.hasActiveItem = this.activeItem.length;

			if(!this.hasActiveItem){
				this.activeItem = this.items.eq(0);
				this.lavaLampItem.addClass('lavalamp-hidden');
			}
			this.setAvtive();
			this.animateLamp(this.activeItem);
		},
		attachEvents: function() {
			var self = this;

			// handle resize
			this.resizeHandler = function() {
				self.animateLamp(self.activeItem);
			};

			jQuery(window).on('load resize orientationchange', this.resizeHandler);

			// enter handle
			this.enterHandler = function() {
				var item = $(this);

				clearTimeout(self.delayOnTimer);
				clearTimeout(self.delayOffTimer);

				self.delayOnTimer = setTimeout(function(){
					if (!self.hasActiveItem) {
						self.activeItem = item;
					}
					self.lavaLampItem.removeClass('lavalamp-hidden');
					self.animateLamp(item, true);
				}, self.options.delayOn);
			};

			// leave handle
			this.leaveHandler = function() {
				clearTimeout(self.delayOffTimer);
				clearTimeout(self.delayOnTimer);

				self.delayOffTimer = setTimeout(function(){
					if(!self.hasActiveItem){
						self.lavaLampItem.addClass('lavalamp-hidden');
					}
					self.animateLamp(self.activeItem, true);
				}, self.options.delayOff);

			};
			// click handle
			this.clickHandler = function() {
				if (self.options.setOnClick) {
					self.activeItem = $(this);

					clearTimeout(self.delayOffTimer);
					clearTimeout(self.delayOnTimer);

					self.setAvtive().animateLamp(self.activeItem, true);
				}
			};

			this.items
				.on('mouseenter', this.enterHandler)
				.on('mouseleave', this.leaveHandler);

			if (self.options.setOnClick) {
				this.items.on('click', this.clickHandler);
			}
		},
		setAvtive: function() {
			this.items.removeClass(this.options.activeLampClass);
			this.activeItem.addClass(this.options.activeLampClass);
			return this;
		},
		animateLamp: function(curItem, animate){
      if (!curItem) {
        return;
      }
      if (!curItem.length) {
        return;
      }

			var self = this;
			var position = this.calcOffsets(curItem);

			if (!animate) {
				this.lavaLampItem.css({
					transitionDuration: '0s'
				});
			} else {
				this.lavaLampItem.css({
					transitionDuration: this.options.duration + 'ms'
				});
			}

			this.lavaLampItem.css(position);

			this.lavaLampItem.css({
				transitionDuration: this.options.duration + 'ms'
			});

		},
		calcOffsets: function(curItem){
			var holderOffset = this.holder.offset();
			var itemOffset = curItem.offset();
			var itemWidth = curItem.outerWidth();
			var itemHeight = curItem.outerHeight();

			return {
				left: itemOffset.left - holderOffset.left,
				top: itemOffset.top - holderOffset.top,
				width: itemWidth,
				height: itemHeight
			};
		},
		destroy: function() {
			this.lavaLampItem.remove();

			jQuery(window).off('load resize orientationchange', this.resizeHandler);

			this.items
				.off('mouseenter', this.enterHandler)
				.off('mouseleave', this.leaveHandler);
			if (this.options.setOnClick) {
				this.items.off('click', this.clickHandler);
			}
			this.holder.removeClass('lavalamp-ready').removeData('LavaLamp').css({
				position: '',
				transitionDuration: '',
				zIndex: ''
			});
		},
		makeCallback: function(name) {
			if(typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	// jQuery plugin interface
	$.fn.lavaLamp = function(opt) {
		return this.each(function() {
			jQuery(this).data('LavaLamp', new LavaLamp($.extend(opt, { holder: this })));
		});
	};
}(jQuery));